import {Box, MenuItem, TextField, Typography} from "@mui/material";
import {platforms, resolutions} from "./AssetsConfig";

interface IEncoding {
    config: any
    platform: string
    resolution: string
}
function Encoding({config, platform, resolution}: IEncoding) {
    const values = Object.keys(config.video_jobs).filter(resolution => config.video_jobs[resolution]);

    return (
        <TextField label={`${platform} ${resolution}`} select size="small" sx={{margin: 1}}
                   value={config.platform_encoders[platform][resolution] ?? ""}>
            <MenuItem value="">None</MenuItem>
            {values.map(resolution =>
                <MenuItem key={resolution} value={resolution}>{resolution}</MenuItem>
            )}
        </TextField>
    );
}
interface IVideoEncoding {
    config: any
    project: string
}
export function VideoEncoding({config, project}: IVideoEncoding) {
    if (! config.video_jobs) {
        return null;
    }
    return (
        <Box flexGrow={1}>
            <Typography>
                This maps the format requested within cookbook to a source format.
            </Typography>
            <Box display="flex">
                {resolutions.map(resolution =>
                    <Box display="flex" flexDirection="column" flexGrow={1} key={resolution}>
                        {platforms.map(platform =>
                            <Encoding config={config} key={platform} platform={platform} resolution={resolution}/>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    );
}